module.exports = __webpack_public_path__ + "static/img_14-5ad001da833dc5dfe6f6f3f7d7fa382e.png";